export const feedbackFilterColors = {
    all: 'info',
    issue: 'danger',
    idea: 'warning',
    other: 'graydark',
};

export const feedbackFilterLabels = {
    all: 'Todos',
    issue: 'Problemas',
    idea: 'Ideias',
    other: 'Outros',
};
